export default {"src":"/_next/static/media/close.636f1f66.svg","height":22,"width":22};